import { matchPath } from '@umijs/max';

type PermissionUserVO = Pick<
  UserAPI.CurrentUser,
  'pid' | 'isSuperuser' | 'hasRoutes' | 'hasAccess'
>;

function normalizePermissionPath(path: string): string {
  return path.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
}

export function hasPermission(user: PermissionUserVO | undefined, code: string): boolean {
  return !!user?.pid && (user.isSuperuser === true || (user.hasAccess ?? []).includes(code));
}

export function hasMenuAccess(user: PermissionUserVO | undefined, path: string): boolean {
  return !!user?.pid && (user.isSuperuser === true || (user.hasRoutes ?? []).some((grant) => (
    matchPath(
      { path: normalizePermissionPath(grant), end: true, caseSensitive: true },
      normalizePermissionPath(path),
    ) !== null
  )));
}
